























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import JSONEditor from 'jsoneditor'
import { find, sortBy } from 'lodash'
import { Equipment } from '@/interfaces'
import AdminEditMixin from '@/mixins/AdminEditMixin'

let editor: JSONEditor
let editorElement: HTMLElement

@Component
export default class AdminEditEquipment extends Mixins(AdminEditMixin) {
  @Prop({ default: '' }) equipmentId!: string
  @Watch('selected')
  onSelected (equipment: Equipment) {
    editor.set(equipment)
  }

  readOnlyFields: Set<String> = new Set(['id', 'created', 'updated'])
  selected: Equipment|null = null

  created () {}

  mounted () {
    // TODO: enable this when advanced mode selected
    // this.loadEditor()

    this.selected = find(this.sortedEquipment, { id: this.equipmentId }) || null
  }

  get sortedEquipment (): Equipment[] {
    return sortBy(this.$store.getters['equipment/all'], 'name.en')
  }

  addEquipment () {
    this.selected = {
      id: '',
      description: { en: '' },
      name: { en: '' }
    }
  }

  loadEditor () {
    const editorElement = document.getElementById('json-editor')

    if (editorElement) {
      editor = new JSONEditor(editorElement, {
        onEditable: (node) => {
          return {
            field: true,
            value: !this.readOnlyFields.has(node.field)
          }
        }
      })
    }
  }

  async removeEquipment (equipment: Equipment) {
    try {
      await this.$store.dispatch('equipment/removeBase', equipment)

      this.selected = null
    } catch (error) {
      // TODO: display some kind of useful error message
    } finally {
      this.hideConfirmRemoveDialog()
    }
  }

  saveEquipment (equipment: Equipment) {
    this.$store.dispatch('equipment/saveBase', equipment)
  }

  setActive (equipment: Equipment) {
    this.selected = equipment
    this.$router.push({ name: 'admin-edit-equipment', params: { equipmentId: equipment.id } })
  }
}
